import { FlagIcon } from './FlagIcon';

/**
 * author: Google
 * id 55271063-77EF-43FA-917C-657E57135A24
 * name flag
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flag.svg
 * tags
 */
export const AssistantPhotoIcon = FlagIcon;
export default AssistantPhotoIcon